import React, { Component } from "react";
import { Form, Grid, Card } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import TablePageable from "../../Helpers/TablePageable.react";

class Failure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      accion: this.props.accion,
      failures: [],
      perfilesFailure: [],
    };
  }

  componentDidMount = () => {
    if (this.state.accion !== "nuevo") {
      this.setState({ id: this.props.elementos.id });
      this.cargaFailures();
      this.cargaPerfilesFailure(this.props.elementos.id);
    }
  };

  cargaFailures = () => {
    Crud_Catalogos("service_failure", "", "get", "", [], "", "", "", [], "", "", "")
      .then((returnVal) => {
        this.setState({ failures: returnVal });
      })
      .catch((err) => {
        console.log("Error al cargar failures:", err);
      });
  };

  cargaPerfilesFailure = (idPerfil) => {
    Crud_Catalogos("perfilesFailure", "", "get", "", [], "", "", "", [], "", "", "/" + idPerfil)
      .then((returnVal) => {
        this.setState({ perfilesFailure: returnVal });
      })
      .catch((err) => {
        console.log("Error al cargar perfilesFailure:", err);
      });
  };

  isFailureActivo = (failureId) => {
    return this.state.perfilesFailure.some((pf) => pf.idFailure === failureId);
  };

  changeFailure = (failure) => {
    const idPerfil = this.state.id;
    const idFailure = failure.id;

    if (this.isFailureActivo(idFailure)) {
      // DELETE
      Crud_Catalogos("perfilesFailure/" + idPerfil, "", "delete", idFailure, "", "", "", "", [], "", "", "")
        .then(() => {
          const updated = this.state.perfilesFailure.filter((pf) => pf.idFailure !== idFailure);
          this.setState({ perfilesFailure: updated });
        })
        .catch((err) => {
          console.log("Error al eliminar perfilFailure:", err);
        });
    } else {
      // POST
      const obj = { idPerfil: idPerfil, idFailure: idFailure };
      Crud_Catalogos("perfilesFailure", "", "post", "", obj, "", "", "", [], "", "", "")
        .then((returnVal) => {
          const updated = [...this.state.perfilesFailure, returnVal];
          this.setState({ perfilesFailure: updated });
        })
        .catch((err) => {
          console.log("Error al agregar perfilFailure:", err);
        });
    }
  };

  getListaConEstatus = () => {
    return this.state.failures.map((f) => ({
      ...f,
      activo: this.isFailureActivo(f.id),
    }));
  };

  render() {
    return (
      <div>
        {this.state.accion === "modificar" ? (
          <div>
            <Grid.Row>
              <Grid.Col>
                <Card
                  title="Service Failure"
                  isCollapsible={false}
                  isCollapsed={false}
                  body={
                    <div>
                      <TablePageable
                        lista={this.getListaConEstatus()}
                        columnas={[
                          { columna: "id", label: "ID" },
                          { columna: "categoria.nombre", label: "Categoría" },
                          { columna: "nombre", label: "Nombre" },
                          {
                            columna: "activo",
                            label: "Asignado",
                            form: (registro) => (
                              <Form.Switch
                                type="Checkbox"
                                name="toggle"
                                value="option1"
                                checked={registro.activo}
                                className={"disabled"}
                                onChange={() => this.changeFailure(registro)}
                              />
                            ),
                          },
                        ]}
                        id="id"
                        paginacion={true}
                        elementosPorPagina={20}
                      />
                    </div>
                  }
                />
              </Grid.Col>
            </Grid.Row>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Failure;
